import { NavLink } from "react-router-dom";
import { useRef } from "react";
import { Collapse } from "bootstrap";

export const Navbar = () => {
    const collapseRef = useRef<HTMLDivElement>(null);

    const handleNavLinkClick = () => {
        if (collapseRef.current) {
            const bsCollapse =
                Collapse.getInstance(collapseRef.current) ||
                new Collapse(collapseRef.current);
            bsCollapse.hide();
        }
    };

    return (
        <nav className="navbar navbar-expand-md bg-dark navbar-dark">
            <div className="container">
                <img
                    className="mx-2"
                    src="../images/DSLogoSm.png"
                    alt="Logo"
                    width="35rem"
                    height="35rem"
                />
                <NavLink
                    to="/home"
                    className="nav-link"
                    onClick={handleNavLinkClick}
                >
                    <span className="navbar-brand anton-regular-nav text-white">
                        Dragonshifty Studios
                    </span>
                </NavLink>

                <button
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    className="navbar-toggler"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div
                    className="collapse navbar-collapse"
                    id="navbarNav"
                    ref={collapseRef}
                >
                    <ul className="navbar-nav ms-auto">
                        <li className="nav-item anton-regular-nav">
                            <NavLink
                                to="/home"
                                className="nav-link"
                                onClick={handleNavLinkClick}
                            >
                                Home
                            </NavLink>
                        </li>

                        <li className="nav-item anton-regular-nav">
                            <NavLink
                                to="/hittingtherightnote"
                                className="nav-link"
                                onClick={handleNavLinkClick}
                            >
                                Right Note
                            </NavLink>
                        </li>
                        <li className="nav-item anton-regular-nav">
                            <NavLink
                                to="/davesday"
                                className="nav-link"
                                onClick={handleNavLinkClick}
                            >
                                Dave's Day
                            </NavLink>
                        </li>
                        <li className="nav-item anton-regular-nav">
                            <NavLink
                                to="/diffrentia"
                                className="nav-link"
                                onClick={handleNavLinkClick}
                            >
                                Diffrentia
                            </NavLink>
                        </li>
                        <li className="nav-item anton-regular-nav">
                            <NavLink
                                to="/about"
                                className="nav-link"
                                onClick={handleNavLinkClick}
                            >
                                About
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};
